import type { IconData } from '@stacksjs/iconify-core'

export const iceCreamF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M6 14v5a1 1 0 0 1-2 0v-5H3a3 3 0 0 1-3-3V5a5 5 0 1 1 10 0v6a3 3 0 0 1-3 3z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default iceCreamF
